import { formatLeadDate } from './leadFormat';

export const DEFAULT_WA_TEMPLATE =
  '*New Lead from GOBRA website*\n' +
  'Name: {name}\nPhone: {phone}\nEmail: {email}\n' +
  'Project: {project}\nMessage: {message}\nStatus: {status}\nReceived: {date}';

export const DEFAULT_EMAIL_TEMPLATE =
  'New enquiry from the GOBRA website\n\n' +
  'Name: {name}\nMobile: {phone}\nEmail: {email}\n' +
  'Project: {project}\nMessage: {message}\nStatus: {status}\nReceived: {date}\n';

export const SAMPLE_LEAD = {
  name: 'Ahmed Khan',
  mobile: '+971501234567',
  email: 'ahmed@example.com',
  project: 'Fleurs de Jardin',
  note: 'I am interested in a 3-bedroom villa.',
  status: 'New',
  ownerName: 'Dhayglysth Gomes',
  createdAt: new Date().toISOString(),
};

export const WA_PLACEHOLDERS = ['{name}', '{phone}', '{email}', '{project}', '{message}', '{status}', '{owner}', '{date}'];

export const renderLeadTemplate = (tpl, l = {}) =>
  (tpl || DEFAULT_WA_TEMPLATE)
    .split('{name}').join(l.name || '')
    .split('{phone}').join(l.mobile || '')
    .split('{email}').join(l.email || '')
    .split('{project}').join(l.project || '')
    .split('{message}').join(l.note || '')
    .split('{status}').join(l.status || 'New')
    .split('{owner}').join(l.ownerName || '')
    .split('{date}').join(l.createdAt ? formatLeadDate(l.createdAt) : '');

// Opens WhatsApp compose for a given number (any format) with the message.
export const openWhatsApp = (number, message) => {
  const digits = String(number || '').replace(/\D/g, '');
  if (!digits) return false;
  window.open(`https://wa.me/${digits}?text=${encodeURIComponent(message)}`, '_blank');
  return true;
};
